import { useEffect, useRef } from "react";
import { motion, useInView, animate } from "framer-motion";

// `instant` : rend le bloc immédiatement visible sans animation d'entrée —
// utilisé sur le premier écran des pages prerendues pour un LCP stable (pas de
// flash opacité 0 au montage React alors que le HTML statique a déjà peint).
export const Reveal = ({ children, delay = 0, y = 36, className = "", instant = false, ...rest }) => (
  <motion.div
    initial={instant ? false : { opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Counter = ({ to, prefix = "", suffix = "", className = "", ...rest }) => {
  const ref = useRef(null);
  const numRef = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  // U+202F narrow no-break space: thousands separator that can never wrap
  const format = (n) => String(n).replace(/\B(?=(\d{3})+(?!\d))/g, "\u202F");
  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, to, {
      duration: 1.8,
      ease: [0.16, 1, 0.3, 1],
      // Write straight to the DOM node — no React re-render per frame
      onUpdate: (v) => {
        if (numRef.current) numRef.current.textContent = format(Math.round(v));
      },
    });
    return () => controls.stop();
  }, [inView, to]);
  const final = `${prefix}${format(to)}${suffix}`;
  return (
    <span
      ref={ref}
      className={`relative inline-block whitespace-nowrap tabular-nums ${className}`}
      {...rest}
    >
      {/* Invisible final value reserves the exact final width: zero layout shift */}
      <span className="invisible" aria-hidden="true">{final}</span>
      <span className="absolute inset-0" aria-label={final}>
        {prefix}
        <span ref={numRef}>0</span>
        {suffix}
      </span>
    </span>
  );
};

export const Kicker = ({ children, light = false, className = "" }) => (
  <p className={`text-xs font-semibold uppercase tracking-[0.28em] ${light ? "text-[#4DB8FF]" : "text-[#2E8BFF]"} ${className}`}>
    {children}
  </p>
);
